export const JobQueueStatusReportsSelector = ({ admin }) =>
  admin.jobQueueStatusReports.jobQueueStatusReports;

export const isFetchingJobQueueStatusReportsSelector = ({ admin }) =>
  admin.jobQueueStatusReports.isFetchingJobQueueStatusReports;

export const isTerminatedStuckCalcJobSelector = ({ admin }) =>
  admin.jobQueueStatusReports.isTerminatedStuckCalcJob;
